
import { combineReducers } from "redux";
import productsReducer from "./products/reducers";
import bundleDataReducer from "./bundleData/reducers";
import bundleReducer from "./bundle/reducers";

const manhattanReducer = combineReducers({
  bundleProduct: bundleReducer,
  products: productsReducer,
  bundleData: bundleDataReducer,
});


export default manhattanReducer;
